export const theme = {
  token: {
    // Color Palette
    colorPrimary: "#00529B", // A deeper, more professional blue
    colorInfo: "#00529B",
    colorSuccess: "#4CAF50",
    colorWarning: "#FFC107",
    colorError: "#F44336",
    colorTextBase: "#333333",
    colorBgBase: "#f5f5f5", // A slightly lighter grey for background

    // Typography
    fontFamily: "'Roboto', sans-serif",
    fontSize: 16, // Base font size

    // Spacing & Sizing
    borderRadius: 12, // Softer corners
    controlHeight: 40,
  },
  components: {
    Layout: {
      headerBg: "#ffffff",
      bodyBg: "#f0f2f5",
      siderBg: "#ffffff",
    },
    Card: {
      boxShadow: "0 1px 2px -2px rgba(0, 0, 0, 0.16), 0 3px 6px 0 rgba(0, 0, 0, 0.12), 0 5px 12px 4px rgba(0, 0, 0, 0.09)",
      borderRadius: 12, // Cập nhật để nhất quán với token.borderRadius
      headPadding: '16px',
    },
    Button: {
      borderRadius: 12, // Cập nhật để nhất quán với token.borderRadius
      controlHeight: 40,
    },
    Input: {
      borderRadius: 12, // Cập nhật để nhất quán với token.borderRadius
      controlHeight: 40,
    },
    Select: {
      borderRadius: 12, // Cập nhật để nhất quán với token.borderRadius
      controlHeight: 40,
    },
    Statistic: {
      titleFontSize: 16,
    }
  },
};
